import { Logout } from '@oresundsbron/icons';
import { PrivateCustomer } from '@oresundsbron/validators';
import { useTranslation } from 'next-i18next';
import { useMemo } from 'react';
import { useCustomerInformation } from '../../../hooks/useCustomerInformation';
import { NextPageWithLayout } from '../../../pages/_app';
import CustomerStatus from './CustomerStatus';
import PrivateDashboard from './Private';
import { Box, Button } from '@oresundsbron/bridge-ui';
import { getCustomerStatus, getProviderInfo } from './utils';
import ProviderInfo from './ProviderInfo';
import {
  NoRecognitionInfo,
  useActiveRecognitions,
  useAgreementGroupList,
  useLogout,
} from '@oresundsbron/app-common';
import { OresundPAY } from '@oresundsbron/validators/src/constants';
import { useFlags } from '~/components/Flags';

const Dashboard: NextPageWithLayout = () => {
  const { t } = useTranslation(['account', 'common'], {
    nsMode: 'fallback',
  });

  const { customerInformation } = useCustomerInformation();
  const customerStatus = useMemo(
    () => getCustomerStatus(customerInformation as PrivateCustomer | undefined),
    [customerInformation]
  );
  const providerInfo = useMemo(
    () => getProviderInfo(customerInformation as PrivateCustomer | undefined),
    [customerInformation]
  );
  const { data } = useAgreementGroupList(false);
  const flags = useFlags();
  const flagShowAlprInSignup = !!flags?.get('showAlprInSignup');
  const oresundPayProvider = useMemo(
    () =>
      data?.some((c) => c.paymentAgreement.provider.name === OresundPAY) ??
      false,
    [data]
  );
  const { activeRecognitions, recognitionChoices, loading } =
    useActiveRecognitions();
  const noRecognition = useMemo(
    () =>
      activeRecognitions.length === 0 &&
      recognitionChoices.length === 0 &&
      !loading &&
      oresundPayProvider,
    [activeRecognitions, recognitionChoices, loading, oresundPayProvider]
  );
  const onLogout = useLogout();

  return (
    <Box className="my-4 md:my-6">
      <CustomerStatus status={customerStatus} />
      <ProviderInfo info={providerInfo} />
      {noRecognition && !flagShowAlprInSignup && <NoRecognitionInfo />}
      <PrivateDashboard />
      <Box className="mt-5 flex justify-center">
        <Button intent="solid" startIcon={<Logout />} onClick={onLogout}>
          {t('action.logout')}
        </Button>
      </Box>
    </Box>
  );
};

export default Dashboard;
